import FontIcon, { loadFontIcons as load } from './FontIcon'

export const loadFontIcons = load

export default FontIcon
